import React, { FormEvent } from "react"
import CommunityGuidelinesAgreement from "../CommunityGuidelinesAgreement"

interface AssetMap {
  phoneInHand: string
  close: string
}

interface NewFeedPostCommentProps {
  action: string
  communityGuidelinesAgreementRequired: boolean
  assets: AssetMap
}

export default function NewFeedPostComment(props: NewFeedPostCommentProps) {
  const { action, assets } = props
  const [communityGuidelinesAgreementRequired, setCommunityGuidelinesAgreementRequired] = React.useState(
    props.communityGuidelinesAgreementRequired
  )
  const [message, setMessage] = React.useState("")
  const [error, setError] = React.useState("")
  const [showCommunityGuidelines, setShowCommunityGuidelines] = React.useState(false)
  const commentsRef = React.useRef(document.getElementById("comments"))
  const feedPostRef = React.useRef(document.getElementById("feed-post"))

  React.useEffect(() => {
    feedPostRef.current.style.display = showCommunityGuidelines ? "none" : "block"
  }, [showCommunityGuidelines])

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (communityGuidelinesAgreementRequired) {
      window.scrollTo(0, 0)
      setShowCommunityGuidelines(true)
    } else {
      submitForm()
    }
    return false
  }

  async function submitForm() {
    setShowCommunityGuidelines(false)
    try {
      const response = await fetch(action, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({ message })
      })

      if (response.status === 200) {
        commentsRef.current.innerHTML = await response.text()
        setMessage("")
        setError("")
        setCommunityGuidelinesAgreementRequired(false)
        setShowCommunityGuidelines(false)
        commentsRef.current.scrollIntoView({ behavior: "instant", block: "end" })
      } else {
        let errorMessage = "Could not save comment"
        if (response.status === 422) {
          const data = await response.json()
          if (data.error) {
            errorMessage = data.error
          }
        }
        console.error(`Could not save comment, HTTP ${response.status} error`, errorMessage)
        setError(errorMessage)
      }
    } catch (error) {
      console.error("Could not save comment, fetch error", error)
      setError(`Could not save comment`)
    }
  }

  if (showCommunityGuidelines) {
    return <CommunityGuidelinesAgreement assets={assets} onAgree={submitForm} />
  }

  return (
    <div className="new-comment-container">
      <div className="new-comment">
        {error && (
          <div id="error" style={{ marginBottom: "1rem" }}>
            {error}
          </div>
        )}
        <form action={action} method="post" onSubmit={handleSubmit}>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            name="message"
            placeholder="Write a comment..."
            className="form-control"
            style={{ height: message && message.length > 30 ? 108 : 42 }}
          />
          <button type="submit" disabled={!message || message.length === 0}>
            <i className="fa-solid fa-paper-plane-top"></i>
          </button>
        </form>
      </div>
    </div>
  )
}
